'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseModal = function CloseModal(props) {
    var _props$closeAfterClic = props.closeAfterClick,
        closeAfterClick = _props$closeAfterClic === undefined ? true : _props$closeAfterClic,
        closeModal = props.closeModal,
        onClick = props.onClick,
        rest = props.rest,
        className = props.className;

    var handleClick = function handleClick(e) {
        if (onClick) {
            onClick(e);
        }
        if (closeAfterClick) {
            closeModal(e);
        }
    };
    var buttonProps = Object.assign({}, rest, { onClick: handleClick, className: (0, _classnames2.default)('luna-modal__close', [className]) });
    return _react2.default.createElement(_Button2.default, Object.assign({}, buttonProps));
};
CloseModal.propTypes = {
    closeAfterClick: _propTypes2.default.bool.isRequired,
    closeModal: _propTypes2.default.func.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string.isRequired,
    rest: _propTypes2.default.node.isRequired
};
exports.default = CloseModal;
//# sourceMappingURL=ModalClose.js.map